export default __webpack_public_path__ + "static/media/announcement_5_lyte@2x.792dd562.png";